const getEarliestMilestoneStartDate = (initiative) => {
    if (!initiative || !initiative.milestones || !Array.isArray(initiative.milestones) || initiative.milestones.length === 0) {
      return null;
    }
  
    let earliestStartDate = null;
  
    initiative.milestones.forEach((milestone) => {
      const startDate = milestone.startDate ? new Date(milestone.startDate) : null;
  
      if (startDate) {
        if (!earliestStartDate || startDate < earliestStartDate) {
          earliestStartDate = startDate;
        }
      }
    });
  
    return earliestStartDate ? earliestStartDate.toISOString().split('T')[0] : null;
  };
  export default getEarliestMilestoneStartDate